import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectRatio2To124(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconMediaObjectRatio2To124"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5 4.5h6A1.5 1.5 0 0 1 12.5 6v12a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 18V6A1.5 1.5 0 0 1 5 4.5M2 6a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm14.81-.25a.75.75 0 0 1 .75-.75h3.708a.75.75 0 0 1 0 1.5H17.56a.75.75 0 0 1-.75-.75m0 6a.75.75 0 0 1 .75-.75h3.708a.75.75 0 0 1 0 1.5H17.56a.75.75 0 0 1-.75-.75M17.56 8a.75.75 0 0 0 0 1.5h2.122a.75.75 0 0 0 0-1.5zm-.75 6.75a.75.75 0 0 1 .75-.75h2.122a.75.75 0 0 1 0 1.5H17.56a.75.75 0 0 1-.75-.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectRatio2To124);
